import { put, call, take, select } from "redux-saga/effects";
import { actions as navActions } from "@actions/navigation.actions";
import {
  SET_FETCH_ME_COMPLETED,
  SET_HOME_MOUNTED,
} from "@reducers/actionTypes";

function* beforeNavigation(params) {
  const { fetchMeCompleted } = yield select(
    ({ auth: { fetchMeCompleted } }) => ({
      fetchMeCompleted,
    }),
  );
  if (!fetchMeCompleted) {
    yield take(SET_FETCH_ME_COMPLETED);
  }
  const homeMounted = yield select(({ misc: { homeMounted } }) => homeMounted);
  if (!homeMounted) {
    yield take(SET_HOME_MOUNTED);
  }
  const appScreen = params.app_screen;
  let routeName = appScreen;
  let routeParams = {};
  return {
    routeName,
    routeParams: {
      ...params,
      ...routeParams,
    },
  };
}

export default function* navigate(action) {
  try {
    const { params } = action;
    const routeConfig = yield beforeNavigation(params);
    const { routeName, routeParams } = routeConfig || {};
    yield call(
      () =>
        new Promise((resolve) =>
          setTimeout(() => {
            resolve();
          }, 200),
        ),
    );
    if (routeName) {
      yield put(navActions.navigate([routeName, routeParams]));
    }
  } catch (e) {
    console.log(e, "error navigating via deeplink params");
  }
}
